// Reading and writing the saved theme preference.
//
// Every localStorage call is wrapped: Safari in private mode throws on write
// once its quota is reached, and an embedded frame with third-party cookies
// blocked throws on the *getter itself*. Neither is worth taking the app down
// for — the theme just falls back to the default for that session.

import { THEMES, THEME_STORAGE_KEY } from "./themeConstants";

/** True for the two values we accept as a stored preference. */
export const isValidTheme = (value) => THEMES.includes(value);

/**
 * The saved preference, or null when there is nothing usable stored.
 * Anything unrecognised — a hand-edited value, or "system" left behind by the
 * release that still offered it — is treated as absent rather than trusted.
 */
export const readStoredTheme = () => {
    try {
        const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
        return isValidTheme(stored) ? stored : null;
    } catch {
        return null;
    }
};

/**
 * Persist a preference. Returns whether it actually stuck, so callers can tell
 * "saved" from "applied for this session only".
 */
export const writeStoredTheme = (theme) => {
    if (!isValidTheme(theme)) {return false;}
    try {
        window.localStorage.setItem(THEME_STORAGE_KEY, theme);
        return true;
    } catch {
        return false;
    }
};

/** Drop the preference, putting the user back on the default. */
export const clearStoredTheme = () => {
    try {
        window.localStorage.removeItem(THEME_STORAGE_KEY);
        return true;
    } catch {
        return false;
    }
};
